module.exports = __webpack_public_path__ + "img/weather_tornado.2259f79d.png";